<template>
  <div>
    <div class="mains" v-if="loading" v-loading="loading" element-loading-spinner="el-icon-loading"></div>
    <div v-else>
      <div class="man-title">
        <span>档案记录</span>
      </div>
      <!-- <div class="box-content">
        <div>
          <div class="title">巡检档案</div>
          <div>
            <div class="data"> {{ data.deviceCount ? data.deviceCount : 0 }} <span>份</span></div>
            <div class="data"> {{ data.deviceCount ? data.deviceCount : 0 }} <span>条</span></div>
          </div>
        </div>
        <div>
          <div class="title">点检档案</div>
          <div>
            <div class="data"> {{ data.completeCount ? data.completeCount : 0 }} <span>份</span></div>
            <div class="data"> {{ data.completeCount ? data.completeCount : 0 }} <span>条</span></div>
          </div>
        </div>
        <div>
          <div class="title">检修档案</div>
          <div>
            <div class="data"> {{ data.incompleteCount ? data.incompleteCount : 0 }} <span>份</span></div>
            <div class="data"> {{ data.incompleteCount ? data.incompleteCount : 0 }} <span>条</span></div>
          </div>
        </div>
        <div>
          <div class="title">润滑档案</div>
          <div>
            <div class="data"> {{ data.abnormalCount ? data.abnormalCount : 0 }} <span>份</span></div>
            <div class="data"> {{ data.abnormalCount ? data.abnormalCount : 0 }} <span>条</span></div>
          </div>
        </div>
      </div> -->
      <div class="search">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="设备识别号">
            <el-input size="small" v-model="form.deviceNum" clearable placeholder="请输入设备识别号"></el-input>
          </el-form-item>
          <el-form-item label="设施位置">
            <el-select size="small" v-model="form.facilityId" clearable placeholder="请选择设施位置">
              <el-option
                v-for="item in weizhi"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="departmentId">
            <el-select size="small" v-model="form.departmentId" clearable placeholder="请选择所属部门">
              <el-option
                v-for="item in bumen"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称">
            <el-select size="small" v-model="form.deviceId" clearable placeholder="请选择设备名称">
              <el-option
                v-for="item in device"
                :label="item.name"
                :value="item.name"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select size="small" v-model="form.deviceTypeId" clearable placeholder="请选择设备类型">
              <el-option
                v-for="item in leixin"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备状态">
            <el-select size="small" v-model="form.zhuangtaiId" clearable placeholder="请选择设备状态">
              <el-option
                v-for="item in zhuangtai"
                :label="item.name"
                :value="item.id"
                :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="ein" label="设备识别号"></el-table-column>
          <el-table-column prop="alias" label="设备别名"></el-table-column>
          <el-table-column prop="facilityName" label="设施位置"></el-table-column>
          <el-table-column prop="departmentName" label="所属部门"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称"></el-table-column>
          <el-table-column prop="deviceTypeName" label="设备类型"></el-table-column>
          <el-table-column prop="deviceStatus" label="设备状态" width="80">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.deviceStatus == 1">正常</el-tag>
              <el-tag type="danger" v-if="scope.row.deviceStatus == 2">异常</el-tag>
              <el-tag type="warning" v-if="scope.row.deviceStatus == 3">未知</el-tag>
              <el-tag type="info" v-if="scope.row.deviceStatus == 4">停用</el-tag>
              <el-tag type="info" v-if="scope.row.deviceStatus == 5">报废</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="inspectionCount" label="巡检（条）" width="120">
            <template slot-scope="scope">
              {{ scope.row.inspectionCount ? scope.row.inspectionCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="checkCount" label="点检（条）" width="120">
            <template slot-scope="scope">
              {{ scope.row.checkCount ? scope.row.checkCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="reconditionCount" label="检修（条）" width="120">
            <template slot-scope="scope">
              {{ scope.row.reconditionCount ? scope.row.reconditionCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="lubricationCount" label="润滑（条）" width="120">
            <template slot-scope="scope">
              {{ scope.row.lubricationCount ? scope.row.lubricationCount : 0 }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-dropdown placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><div @click="details(scope.row)">详情</div></el-dropdown-item>
                  <!-- <el-dropdown-item><div @click="dlt(scope.row)">删除</div></el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <page v-if="total!==0" :size="size" :page="page" :total="total" v-on:sizeChange="sizeChange" v-on:pageChange="pageChange"></page>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/components/page.vue'
import dayjs from 'dayjs';

export default {
  components: {
    page
  },
  data() {
    return {
      loading: false,
      size: 50,
      page: 1,
      total: 0,
      weizhi: [],
      bumen: [],
      device: [],
      leixin: [],
      zhuangtai: [],
      form: {},
      tableData: [],
      data: {}
    }
  },
  methods: {
    dayjs,
    details(row) {
      sessionStorage.setItem('patrolDeviceId', row.patrolDeviceId)
      this.$router.push({ name: 'archivRetDetail', params: {row: row}})
    },
    dlt(row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$ajax.post("ruleDelete", {
          taskRuleId: row.id,
        }).then((res) => {
          this.loadList();
        });
      });
    },
    dateSecond(val) {
      if (val) {
        let s = val % 60
        let _s = val - s
        let m = (_s / 60) % 60
        let h = (_s / 60 - m) / 60
        return `${h>9 ? h:'0'+h}:${m>9 ? m:'0'+m}:${s>9 ? s:'0'+s}`
      } else {
        return '00:00:00'
      }
    },
    loadData() {
      this.$ajax.get('managementStatistics0').then(res => {
        this.data = res.data
      })
    },
    pageChange(val) {
      this.page = val
      sessionStorage.setItem('currentPage', val)
      this.loadList()
    },
    sizeChange(val) {
      this.size = val
      sessionStorage.setItem('currentSize', val)
      this.loadList()
    },
    getLastPage() {
      this.page = Number(sessionStorage.getItem('currentPage')) || 1
    },
    getSize() {
      this.size = Number(sessionStorage.getItem('currentSize')) || 50
    },
    loadList() {
      this.loading = true
      this.$ajax.post('archivesRet', {
        facilityId: this.form.facilityId?this.form.facilityId:null,
        departmentId: this.form.departmentId?this.form.departmentId:null,
        deviceName: this.form.deviceId?this.form.deviceId:null,
        deviceType: this.form.deviceTypeId?this.form.deviceTypeId:null,
        deviceStatus: this.form.zhuangtaiId?this.form.zhuangtaiId:null,
        ein: this.form.deviceNum,
        pageNum: this.page,
        pageSize: this.size
      }).then(res => {
        this.tableData = res.data
        this.total = res.total
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },
    load_weizhi() {
      this.$ajax.get("facilityQueryAll").then((res) => {
        this.weizhi = res.data;
      });
    },
    load_bumen() {
      this.$ajax.get("departmentTree").then((res) => {
        this.bumen = this.getTreeData(res.data);
      });
    },
    getTreeData(data) {
      let arr = [];
      if (Array.isArray(data)) {
        let sss = (d) => {
          d.forEach((item, index) => {
            arr.push({
              id: item.id,
              name: item.name,
            });
            if (item.childTree.length > 0) {
              sss(item.childTree);
            }
          });
        };
        sss(data);
      }
      return arr;
    },
    load_device() {
      this.$ajax.post("deviceChecklist", {
        departmentId: 0,
        deviceTypeId: 0,
        staffId: 0,
      }).then((res) => {
        this.device = res.data;
      });
    },
    load_leixing() {
      this.$ajax.get("typeQueryAll").then((res) => {
        this.leixin = res.data;
      });
    },
    load_zhuangtai() {
      this.$ajax.get("statusQueryAll").then((res) => {
        this.zhuangtai = res.data;
      });
    },
    onSubmit() {
      this.page = 1
      sessionStorage.setItem('currentPage', 1)
      this.loadList()
    }
  },
  mounted() {
    sessionStorage.removeItem('active')
    sessionStorage.removeItem('patrolDeviceId')
    this.getLastPage()
    this.getSize()
    // this.loadData()
    this.loadList()
    this.load_weizhi()
    this.load_bumen()
    this.load_device()
    this.load_leixing()
    this.load_zhuangtai()
  },
  destroyed() {
    // sessionStorage.removeItem('currentPage')
    // sessionStorage.removeItem('currentSize')
  }
}
</script>

<style lang="less" scoped>
.mains {
  padding: 400px 0;
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.box-content {
    display: flex;
    padding-bottom: 20px;
    >div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      height: 76px;
      margin: 0 10px;
      color: #333;
      background: #f5f7fa;
      box-sizing: border-box;
      span {
        font-size: 12px;
        color: #999;
      }
    }
    .title {
      font-size: 12px;
      color: #999;
    }
    .data {
      font-size: 20px;
      margin-top: 8px;
    }
  }
</style>